import { render, staticRenderFns } from "./EventNotifications.vue?vue&type=template&id=7b0b0cbd"
import script from "./EventNotifications.vue?vue&type=script&lang=js"
export * from "./EventNotifications.vue?vue&type=script&lang=js"
import style0 from "./EventNotifications.vue?vue&type=style&index=0&id=7b0b0cbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports